import { useRecoilValueLoadable } from "recoil";
import { ImagePreloader } from "../state/preloader";

function PreLoader() {
  // preload images here to bypass suspense
  useRecoilValueLoadable(ImagePreloader);
  return <></>;
}

export default PreLoader;
